import { useMemo } from 'react';
import { CustomLabel, TimesheetLabel } from '../labelSchema';
import { useIsSmartSuggestionSettingEnabled } from './useIsSmartSuggestionSettingEnabled';
import { getLabelState, LabelState } from './utils';

export const useLabelState = (
  label: TimesheetLabel | CustomLabel | null | undefined,
  disableSuggestions = false
): LabelState => {
  const isSmartSuggestionEnabled =
    useIsSmartSuggestionSettingEnabled() && !disableSuggestions;

  return useMemo(() => {
    return getLabelState(label, isSmartSuggestionEnabled);
  }, [isSmartSuggestionEnabled, label]);
};
